<template>
    <div class="page">
        <box fill>
            <el-form label-position="right" label-width="120px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型编号" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.mtCode">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料类型名称" class="EL-Form-Item">
                        <el-input placeholder="请输入" v-model="pagination.mtName">
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getAuxiMaterialData()">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetData()">
                            重置
                        </el-button>
                    </el-form-item>
                </el-col>
            </el-form>
            <el-divider></el-divider>
            <plabel text="物料类型">
                <el-button v-authority="'BACK_MENU9_M2_B1'" class="btn-t-edit" @click="(add_or_edit = true), (editBoxShow = true)">新增</el-button>
                <el-button v-authority="'BACK_MENU9_M2_B4'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <!-- 展示 -->
            <h-table :headerCellStyle="headerCellStyle" style="flex: 1" @pageChange="getAuxiMaterialData" :data="mainData" pagination :nowPage.sync="pagination.pageNum" :pageSize.sync="pagination.pageSize" :total.sync="pagination.total">
                <el-table-column prop="mtId" label="序号ID" />
                <el-table-column prop="mtCode" label="物料类型编号" />
                <el-table-column prop="mtName" label="物料类型名称" />
                <el-table-column prop="updateTime" label="更新时间" />
                <el-table-column prop="createTime" label="创建时间" />
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button v-authority="'BACK_MENU9_M2_B2'" :disabled="scope.row.mtXa ? true : false" size="mini" type="primary" @click="
                (add_or_edit = false),
                  (editBoxShow = true),
                  (mainObj = JSON.parse(JSON.stringify(scope.row)))
              " plain icon="el-icon-edit-outline" />
                        <el-button v-authority="'BACK_MENU9_M2_B3'" type="danger" @click="deleteRow(scope.row.mtId)" size="mini" plain icon="el-icon-delete" />
                    </template>
                </el-table-column>
            </h-table>
        </box>

        <!-- 新增&&编辑框 -->
        <el-dialog :title="add_or_edit ? '新增' : '编辑'" :close-on-click-modal="false" :visible.sync="editBoxShow" width="700px" :model="mainObj" @open="open">
            <span class="formClass">
                <el-form :inline="true" label-position="top" label-width="80px" :model="mainObj" :rules="rules" ref="mainObj">
                    <el-form-item label="物料类型编号" prop="mtCode">
                        <el-input v-model.trim="mainObj.mtCode"> </el-input>
                    </el-form-item>
                    <el-form-item label="物料类型名称" prop="mtName">
                        <el-input v-model.trim="mainObj.mtName"> </el-input>
                    </el-form-item>
                    <!-- <el-form-item label="标签属性编号：" prop="labelCode">
                        <el-select v-model="mainObj.labelCode" placeholder="请选择" clearable="clearable" multiple collapse-tags>
                            <el-option v-for="item in labelAttrList" :key="item.labelId" :label="item.labelCode + '-' + item.labelName" :value="item.labelCode">{{item.labelCode}}-{{item.labelName}}</el-option>
                        </el-select>
                    </el-form-item> -->
                    <h-table :data="labelAttrList" @selectionChange="handleSelectionChange" ref="multipleTable">
                        <el-table-column type="selection" />
                        <el-table-column prop="labelName" label="标签名称" />
                       <!-- <el-table-column prop="defaultFlag" label="默认状态" >
                            <template slot-scope="scope">
                                <el-radio-group v-model="scope.row.defaultFlag">
                                    <el-radio :label="true">明码</el-radio>
                                    <el-radio :label="false">暗码</el-radio>
                                </el-radio-group>
                            </template>
                        </el-table-column>-->
                    </h-table>
                </el-form>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" type="info" @click="editBoxShow = false">
                    取 消
                </el-button>
                <el-button size="small" type="primary" v-if="add_or_edit" @click="add">
                    新 增
                </el-button>
                <el-button size="small" type="primary" v-else @click="editRow">
                    修 改
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "materialType",
        data() {
            return {
                headerCellStyle: () => {
                    return "background-color: #1f5cec";
                },
                form: {},
                rules: {
                    mtCode: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                    mtName: [{
                        required: true,
                        message: "请输入",
                        trigger: "blur",
                    }, ],
                },
                showRoleBox: true,
                add_or_edit: Boolean, //新增|编辑
                loading: 0, //加载中
                editBoxShow: false, //编辑框
                dialogFormVisible: false,
                formLabelWidth: "140px", // 对话框大小
                tableHeight: 0, //表格高度
                testValue: 1,
                mainObj: {},
                // 新增编辑选中标签属性配置
                labelMatPOList: [],
                // 标签属性列表
                labelAttrList: [],
                pagination: {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    mtCode: "",
                    mtName: "",
                },
                mainData: [],
                fcode: localStorage.getItem("fcCode") || "",

                downloadLoading: false, //下载中

                logContent: "", //操作日志-内容
                logRemarks: "", //操作日志-备注
                // 输入框延时加载
                isSetTimeout: null,
            };
        },
        watch: {
            pagination: {
                handler(newVal) {
                    clearTimeout(this.isSetTimeout)
                    this.isSetTimeout = setTimeout(() => {
                        this.getAuxiMaterialData(newVal);
                    },1000)
                },
                deep: true,
            },
        },
        methods: {
            //获取数据
            getAuxiMaterialData() {
                this.$http
                    .request({
                        url: "/api/materialType/getMaterialTypeAll",
                        method: "GET",
                        params: this.pagination,
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.mainData = resp.data.list || [];
                            this.pagination.total = resp.data.total;
                        }
                    })
                    .catch((error) => {
                        this.loading++;
                    });
            },
            //获取标签属性数据
            getLabelAttrList(mtId) {
                this.$http
                    .request({
                        url: "/api/materialType/getLabelMatList",
                        method: "GET",
                        params: { mtId },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            resp.data.forEach((item) => {
                                item.defaultFlag = item.defaultFlag || false
                            });
                            this.labelAttrList = resp.data || [];
                            this.labelAttrList.forEach(row => {
                                this.$nextTick(() => {
                                this.$refs.multipleTable.$refs.table.toggleRowSelection(row,row.status);
                                });
                            }),
                            this.labelMatPOList = this.labelAttrList.filter(item => item.status)
                        }
                    })
                    .catch((error) => {
                        this.labelAttrList = [];
                        this.labelMatPOList = []
                    });
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },
            //框打开
            open() {
                if (this.add_or_edit) {
                    //新增
                    this.mainObj = JSON.parse(JSON.stringify({}));
                } else {
                    // this.getAuxiMaterialData();
                }
                // 获取标签属性
            this.getLabelAttrList(this.mainObj.mtId)
            },
            //新增
            add() {
                // if (this.fcode != "") {
                //     this.mainObj.fcCode = this.fcode;
                // }
                if (this.submitForm("mainObj")) {
                    if(!this.labelMatPOList.length) return this.$message.error('请勾选标签属性')
                    const { mtCode, mtName } = this.mainObj
                    const data = {
                        mtCode,
                        mtName,
                        labelMatPOList: this.labelMatPOList.map(item => {
                            return {
                                mtCode,
                                labelCode: item.labelCode,
                                defaultFlag: item.defaultFlag,
                                mtCode,
                            }
                        })
                    }
                    this.$http
                        .request({
                            url: "/api/materialType/insertMaterialType",
                            method: "POST",
                            showLoading: true,
                            data,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "新增成功！",
                                    type: "success",
                                });
                                this.logRemarks = "materialType：物料类型新增成功";
                                this.editBoxShow = false;
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "materialType：物料类型新增失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t mtName" +
                                this.mainObj.mtName;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //编辑
            editRow() {
                if (this.submitForm("mainObj")) {
                    if(!this.labelMatPOList.length) return this.$message.error('请勾选标签属性')
                    const { mtCode, mtName, mtId } = this.mainObj
                    const data = {
                        mtId,
                        mtCode,
                        mtName,
                        labelMatPOList: this.labelMatPOList.map(item => {
                            return {
                                mtCode,
                                labelCode: item.labelCode,
                                defaultFlag: item.defaultFlag,
                                mtCode,
                            }
                        })
                    }
                    this.$http
                        .request({
                            url: "/api/materialType/updateMaterialType",
                            method: "POST",
                            showLoading: true,
                            data,
                        })
                        .then((resp) => {
                            if (resp.status == 100) {
                                this.$notify({
                                    title: "成功",
                                    message: "修改成功！",
                                    type: "success",
                                });
                                this.logRemarks = "materialType：物料类型编辑成功";
                                this.editBoxShow = false;
                            } else {
                                this.$notify.error({
                                    title: "失败",
                                    message: resp.message,
                                });
                                this.logRemarks = "materialType：物料类型编辑失败";
                            }
                            this.logContent =
                                "mtCode：" +
                                this.mainObj.mtCode +
                                "\t mtName" +
                                this.mainObj.mtName;
                            this.systemLog();
                            this.getAuxiMaterialData();
                        })
                        .catch((error) => {
                            this.$notify.error({
                                title: "失败",
                                message: "调用失败",
                            });
                        });
                }
            },
            //删除
            deleteRow(mtId) {
                this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                        confirmButtonText: "删除",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                    .then(() => {
                        this.$http
                            .request({
                                url: "/api/materialType/deleteMaterialType",
                                method: "DELETE",
                                showLoading: true,
                                params: {
                                    mtId: mtId,
                                },
                            })
                            .then((resp) => {
                                if (resp.status == 100) {
                                    this.$notify({
                                        title: "成功",
                                        message: "删除成功！",
                                        type: "success",
                                    });
                                    this.logRemarks = "materialType：物料类型删除成功";
                                } else {
                                    this.$notify.error({
                                        title: "失败",
                                        message: "删除失败",
                                    });
                                    this.logRemarks = "materialType：物料类型删除失败";
                                }
                                this.logContent = "mtId：" + mtId;
                                this.systemLog();
                                this.getAuxiMaterialData();
                            })
                            .catch((error) => {
                                this.$notify.error({
                                    title: "失败",
                                    message: "调用失败",
                                });
                            });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            },

            //重置
            resetData() {
                this.pagination = {
                    pageSize: 50,
                    pageNum: 1,
                    total: 0,
                    mtCode: "",
                    mtName: "",
                };
                this.getAuxiMaterialData();
            },

            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    mtCode: this.pagination.mtCode,
                    mtName: this.pagination.mtName,
                    pageNum: 1,
                    pageSize: 999999,
                }

                this.$http.request({
                    url: '/api/materialType/getMaterialTypeAll',
                    method: 'GET',
                    showLoading: true,
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['序号ID', '物料类型编号', '物料类型名称', '更新时间', '创建时间']
                    const filterVal = ['mtId', 'mtCode', 'mtName', 'updateTime', 'createTime']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '物料类型'
                    })
                    this.logContent = "导出"
                    this.logRemarks = "sys_material_type：导出物料类型数据"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },


            /**
             * 操作日志
             */
            systemLog() {
                let objData = {
                    logType: "物料类型",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        data: objData,
                    })
                    .then((resp) => {
                        this.logContent = "";
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            handleSelectionChange(val){
                this.labelMatPOList = val
            }
        },
        activated(){
            /* 获取首页的数据 */
            this.getAuxiMaterialData();
        },
    };
</script>

<style scoped>
</style>
